import React, {forwardRef} from 'react'
import type {FlexProps} from '@chakra-ui/react'

import {Flex, Text} from '../../utils/chakraMonomorphic'
import {FormInput} from '../FormInput/FormInput'

interface Props extends FlexProps {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const AlbumNameControl = forwardRef<HTMLInputElement, Props>(
  ({value, onChange, ...rest}, ref) => (
    <Flex direction='column' {...rest}>
      <FormInput
        title='albumname'
        id='albumname'
        name='name'
        type='text'
        label='Album Name'
        fontSize='16px'
        paddingLeft='11px'
        labelFontSize='16px'
        labelFontWeight='bold'
        placeholder='Name your album'
        labelPaddingTop={2}
        labelPaddingBottom={1}
        labelMarginBottom={0}
        value={value}
        onChange={onChange}
        borderColor='#ced2d5'
        ref={ref}
      />
      <Text color='#7C8791'>100 character max</Text>
    </Flex>
  ),
)

AlbumNameControl.displayName = 'AlbumNameControl'
